import type { HomeDto, OccupancyReportResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import useHomeType from 'hooks/useHomeType'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'

const useOccupancyData = (enabled?: boolean) => {
  const { hasRota } = useHomeType()

  const newFundingTypeActive = hasRota

  const url = newFundingTypeActive
    ? '/api/aggregations/bed-occupancy'
    : '/api/aggregations/bed-occupancy-old'

  const { isLoading, data, error } = useQuery<GetOccupancyResponse>(
    `occupancy`,
    () => getJSON({ url }),
    { enabled }
  )

  const home = useSelector(
    (state: { global: { home: HomeDto } }) => state.global.home
  )

  // const fundingSource = data?.result?.residentFundingSource.map((fundingSource) => )
  const getFundingSource = (): Record<string, number> => {
    const parsedValue: Record<string, number> = {}

    const residentFundingSource = data?.result?.residentFundingSource

    if (!residentFundingSource) {
      return {}
    }

    Object.keys(residentFundingSource).forEach((fundingSourceKey) => {
      const name: string | undefined = home.rotaSettings?.fundingTypes.find(
        (value) => value.id === fundingSourceKey
      )?.name
      if (name) {
        parsedValue[name] = residentFundingSource[fundingSourceKey]
      } else {
        parsedValue[fundingSourceKey] = residentFundingSource[fundingSourceKey]
      }
    })

    return parsedValue
  }

  return {
    data: {
      result: {
        ...data?.result,
        residentFundingSource: getFundingSource()
      } as OccupancyReportResponse
    },
    isLoading,
    error
  }
}

export type GetOccupancyResponse = {
  result?: OccupancyReportResponse
}

export default useOccupancyData
